(() => {
  if (window.__loxBulkScentCapFallback) return;
  window.__loxBulkScentCapFallback = true;

  const rulesByPath = {
    '/products/bulk-soy-candle-packs': { minUnitsPerScent: 12, unitLabel: 'candles' },
    '/products/bulk-soy-candle-gift-packs': { minUnitsPerScent: 12, unitLabel: 'candles' },
    '/products/bulk-room-spray-packs': { minUnitsPerScent: 10, unitLabel: 'sprays' },
    '/products/bulk-room-spray-gift-packs': { minUnitsPerScent: 10, unitLabel: 'sprays' },
    '/products/bulk-car-air-freshener-packs': { minUnitsPerScent: 10, unitLabel: 'fresheners' },
    '/products/bulk-car-air-freshener-gift-packs': { minUnitsPerScent: 10, unitLabel: 'fresheners' },
  };

  function currentRule() {
    return rulesByPath[window.location.pathname] || null;
  }

  function parseCount(text) {
    const match = String(text || '').match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function bulkScentChecks() {
    return Array.from(document.querySelectorAll('.bulk-scent-checkbox'));
  }

  function selectedScentChecks() {
    return bulkScentChecks().filter((input) => input.checked);
  }

  function trimSelectedScents(max) {
    const selected = selectedScentChecks();
    if (selected.length <= max) return false;
    selected.slice(max).forEach((input) => {
      input.checked = false;
    });
    return true;
  }

  function productForm() {
    return document.querySelector('product-form form');
  }

  function currentPackCount() {
    const checkedPackInput = Array.from(document.querySelectorAll('input[type="radio"]:checked')).find((input) =>
      /\d+\s*pack/i.test(input.value)
    );
    if (checkedPackInput) return parseCount(checkedPackInput.value);

    const variantInput = productForm()?.querySelector('[name="id"]');
    const selectedVariantId = variantInput ? String(variantInput.value) : '';
    const analyticsVariants =
      window.ShopifyAnalytics?.meta?.product?.variants || window.meta?.product?.variants || [];
    const selectedVariant = analyticsVariants.find((variant) => String(variant.id) === selectedVariantId);
    return parseCount(selectedVariant?.public_title || selectedVariant?.title);
  }

  function currentQuantity() {
    const input = productForm()?.querySelector('input[name="quantity"]');
    return Math.max(1, parseInt(input?.value || '1', 10) || 1);
  }

  function totalUnits() {
    const packCount = currentPackCount();
    return packCount > 0 ? packCount * currentQuantity() : 0;
  }

  function maxScents() {
    const rule = currentRule();
    if (!rule) return 0;
    const units = totalUnits();
    return Math.max(1, Math.floor(units / rule.minUnitsPerScent));
  }

  function limitText(prefix = '') {
    const rule = currentRule();
    if (!rule) return '';
    const max = maxScents();
    const units = totalUnits();
    const scentWord = max === 1 ? 'scent' : 'scents';
    const quantityText = units > 0 ? `${units} total ${rule.unitLabel}` : 'this pack size';
    return `${prefix}Scent variety limit: ${quantityText} allows up to ${max} ${scentWord}.`;
  }

  function setLimitMessage(isError = false, prefix = '', wasTrimmed = false) {
    const message = document.querySelector('[data-bulk-scent-limit-message]');
    if (!message) return;
    const max = maxScents();
    const selectedCount = selectedScentChecks().length;
    const remaining = Math.max(0, max - selectedCount);
    const remainingText = remaining > 0
      ? ` Select ${remaining} more ${remaining === 1 ? 'scent' : 'scents'} to max out this pack.`
      : " You have reached this pack's scent max.";
    message.textContent = wasTrimmed
      ? `Pack size changed. We kept the first ${max} selected ${max === 1 ? 'scent' : 'scents'}. ${limitText('')}`
      : `${limitText(prefix)}${remainingText}`;
    message.classList.toggle('is-error', isError);
  }

  function syncHiddenScents() {
    const hidden = document.getElementById('bulk-scents-hidden');
    const selected = selectedScentChecks().map((input) => input.value);
    if (hidden) hidden.value = selected.join(', ');
    const display = document.getElementById('selected-scent-display');
    if (display) display.textContent = selected.length ? selected.join(', ') : 'Choose scents below';
  }

  function enforceBulkScentLimit({ showError = false } = {}) {
    if (!currentRule()) return true;
    const checks = bulkScentChecks();
    if (!checks.length) return true;

    const max = maxScents();
    const wasTrimmed = trimSelectedScents(max);
    const selectedCount = selectedScentChecks().length;
    const overLimit = selectedCount > max;

    checks.forEach((input) => {
      input.disabled = !input.checked && selectedCount >= max;
    });

    setLimitMessage(overLimit || showError, overLimit ? 'Too many scents selected. ' : '', wasTrimmed);
    syncHiddenScents();
    return !overLimit;
  }

  function handleScentChange(event) {
    const target = event.target;
    if (!target?.matches?.('.bulk-scent-checkbox')) return;

    if (target.checked && selectedScentChecks().length > maxScents()) {
      target.checked = false;
      setLimitMessage(true, 'That would add too many scents. ');
      syncHiddenScents();
      event.stopPropagation();
      return;
    }

    enforceBulkScentLimit();
  }

  function handleBulkSubmit(event) {
    if (!currentRule() || !bulkScentChecks().length) return;

    const selectedCount = selectedScentChecks().length;
    if (selectedCount < 1) {
      event.preventDefault();
      setLimitMessage(true, 'Choose at least one scent. ');
      return;
    }

    if (!enforceBulkScentLimit({ showError: true })) {
      event.preventDefault();
    }
  }

  function initBulkScentCapFallback() {
    if (!currentRule() || !bulkScentChecks().length) return;
    document.addEventListener('change', handleScentChange, true);
    document.addEventListener('change', () => enforceBulkScentLimit());
    document.addEventListener('input', () => enforceBulkScentLimit());
    document.addEventListener('submit', handleBulkSubmit, true);
    enforceBulkScentLimit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBulkScentCapFallback);
  } else {
    initBulkScentCapFallback();
  }
})();

(() => {
  if (window.__loxGiftSavingsFallback) return;
  window.__loxGiftSavingsFallback = true;

  const prices = {
    candles: {
      'West Palm Beach': 1500,
      'Honeysuckle Jasmine': 1500,
      'Clean Linen': 2200,
      Vanilla: 1500,
      Pine: 1500,
    },
    roomSpray: 2000,
    travelRoomSpray: 1000,
    magnesiumSpray: 2000,
    reedDiffuser: {
      'Tropical Vibes': 2000,
      'Oakmoss & Amber': 2000,
      'Sea Salt & Orchid': 2000,
    },
    freshenerShape: {
      Butterfly: 1000,
      Dolphin: 1200,
      'Sea Turtle': 1200,
      Sunflower: 1000,
    },
  };

  const rulesByPath = {
    '/products/florida-starter-trio-gift-pack': {
      defaultVariant: { title: 'Standard (3 Items)', price: 3900 },
      valueRange: () =>
        addRanges([
          selectedOrFullRange(prices.candles, 'gift-candle-scent'),
          fixedRange(prices.roomSpray),
          selectedOrFullRange(prices.freshenerShape, 'gift-freshener-shape'),
        ]),
    },
    '/products/clean-living-home-refresh-gift-pack': {
      defaultVariant: { title: 'Standard (4 Items)', price: 5400 },
      valueRange: () =>
        addRanges([
          selectedOrFullRange(prices.candles, 'home-refresh-candle-scent'),
          fixedRange(prices.roomSpray),
          selectedOrFullRange(prices.reedDiffuser, 'home-refresh-diffuser-scent'),
          selectedOrFullRange(prices.freshenerShape, 'home-refresh-freshener-shape'),
        ]),
    },
    '/products/night-reset-self-care-gift-pack': {
      defaultVariant: { title: 'Standard (3 Items)', price: 4900 },
      valueRange: () =>
        addRanges([
          selectedOrFullRange(prices.candles, 'night-reset-candle-scent'),
          fixedRange(prices.magnesiumSpray),
          fixedRange(prices.roomSpray),
        ]),
    },
    '/products/new-home-welcome-gift-set': {
      defaultVariant: { title: 'Standard (4 Items)', price: 6200 },
      valueRange: () =>
        addRanges([
          selectedOrFullRange(prices.candles, 'new-home-candle-scent-1'),
          selectedOrFullRange(prices.candles, 'new-home-candle-scent-2'),
          fixedRange(prices.roomSpray),
          selectedOrFullRange(prices.reedDiffuser, 'new-home-diffuser-scent'),
        ]),
    },
    '/products/bridesmaid-thank-you-gift-pack': {
      defaultVariant: { title: '4 Gift Units', price: 7200 },
      valueRange: (variant) =>
        multiplyRange(
          addRanges([fixedRange(prices.travelRoomSpray), selectedOrFullRange(prices.freshenerShape, 'bridesmaid-freshener-shape')]),
          unitsFromVariant(variant)
        ),
    },
    '/products/corporate-appreciation-car-air-freshener-pack': {
      defaultVariant: { title: '25 Units', price: 22500 },
      valueRange: (variant) => multiplyRange(corporateFreshenerRange(), unitsFromVariant(variant)),
    },
  };

  function currentRule() {
    return rulesByPath[window.location.pathname] || null;
  }

  function productForm() {
    return document.querySelector('product-form form');
  }

  function normalizePrice(raw) {
    if (raw == null || raw === '') return 0;
    if (typeof raw === 'string' && raw.includes('.')) return Math.round(parseFloat(raw) * 100);
    return Number(raw) || 0;
  }

  function currentVariant(rule) {
    const selectedVariantId = productForm()?.querySelector('[name="id"]')?.value;
    const analyticsVariants = window.ShopifyAnalytics?.meta?.product?.variants || window.meta?.product?.variants || [];
    const selectedVariant = analyticsVariants.find((variant) => String(variant.id) === String(selectedVariantId));
    if (!selectedVariant) return rule.defaultVariant;
    return {
      title: selectedVariant.public_title || selectedVariant.title || rule.defaultVariant.title,
      price: normalizePrice(selectedVariant.price || selectedVariant.price_amount || rule.defaultVariant.price),
    };
  }

  function unitsFromVariant(variant) {
    const match = String(variant?.title || '').match(/\d+/);
    return match ? Number(match[0]) : 1;
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  function formatMoneyRange(min, max) {
    if (Number(min) === Number(max)) return formatMoney(min);
    return `${formatMoney(min)}-${formatMoney(max)}`;
  }

  function fixedRange(cents) {
    const value = Number(cents || 0);
    return { min: value, max: value };
  }

  function mapRange(map) {
    const values = Object.keys(map || {})
      .map((key) => Number(map[key] || 0))
      .filter(Boolean);
    if (!values.length) return fixedRange(0);
    return { min: Math.min(...values), max: Math.max(...values) };
  }

  function addRanges(ranges) {
    return ranges.reduce(
      (total, range) => {
        total.min += Number(range.min || 0);
        total.max += Number(range.max || 0);
        return total;
      },
      { min: 0, max: 0 }
    );
  }

  function multiplyRange(range, quantity) {
    const qty = Number(quantity || 1);
    return { min: Number(range.min || 0) * qty, max: Number(range.max || 0) * qty };
  }

  function selectedValue(controlId) {
    const control = document.getElementById(controlId);
    return control ? String(control.value || '') : '';
  }

  function selectedOrFullRange(map, controlId) {
    const value = selectedValue(controlId);
    if (value && map?.[value] != null) return fixedRange(map[value]);
    return mapRange(map);
  }

  function corporateFreshenerRange() {
    const shapeFamily = selectedValue('corporate-shape-family');
    if (shapeFamily && prices.freshenerShape[shapeFamily] != null) return fixedRange(prices.freshenerShape[shapeFamily]);
    return mapRange(prices.freshenerShape);
  }

  function injectSavingsStyles() {
    if (document.getElementById('lox-gift-savings-fallback-styles')) return;
    const style = document.createElement('style');
    style.id = 'lox-gift-savings-fallback-styles';
    style.textContent = `
      .lox-gift-savings-card {
        margin: 0 0 1.1rem;
        padding: 1rem;
        border: 1px solid #d4a017;
        border-radius: 14px;
        background: linear-gradient(135deg, #fff8df 0%, #fff 58%, #f6efe0 100%);
        box-shadow: 0 10px 24px rgba(80, 55, 0, 0.08);
      }
      .lox-gift-savings-card__eyebrow {
        margin: 0 0 0.35rem;
        color: #7a5600;
        font-size: 0.75rem;
        font-weight: 800;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }
      .lox-gift-savings-card__headline {
        margin: 0;
        color: #1f1600;
        font-size: 1.25rem;
        font-weight: 800;
        line-height: 1.25;
      }
      .lox-gift-savings-card__detail {
        margin: 0.45rem 0 0;
        color: #5c4630;
        font-size: 0.95rem;
        line-height: 1.45;
      }
    `;
    document.head.appendChild(style);
  }

  function ensureSavingsCard(builder) {
    let card = builder.querySelector('[data-gift-savings-card]');
    if (card) return card;

    card = document.createElement('div');
    card.className = 'lox-gift-savings-card';
    card.setAttribute('data-gift-savings-card', '');
    card.setAttribute('aria-live', 'polite');
    card.innerHTML = `
      <p class="lox-gift-savings-card__eyebrow">Bundle savings</p>
      <p class="lox-gift-savings-card__headline" data-gift-savings-headline>Calculating savings...</p>
      <p class="lox-gift-savings-card__detail" data-gift-savings-detail></p>
    `;

    const stepNote = builder.querySelector('.lox-gift-bundle-builder__step-note');
    const title = builder.querySelector('.lox-gift-bundle-builder__title');
    const anchor = stepNote || title;
    if (anchor?.parentNode) {
      anchor.parentNode.insertBefore(card, anchor.nextSibling);
    } else {
      builder.insertBefore(card, builder.firstChild);
    }
    return card;
  }

  function updateSavings(builder, rule) {
    const card = ensureSavingsCard(builder);
    const headline = card.querySelector('[data-gift-savings-headline]');
    const detail = card.querySelector('[data-gift-savings-detail]');
    if (!headline || !detail) return;

    const variant = currentVariant(rule);
    if (window.location.pathname === '/products/corporate-appreciation-car-air-freshener-pack') {
      headline.textContent = 'Pack pricing for branded gifts';
      detail.textContent = `This is a small corporate-gift pack with logo/color coordination included, not wholesale pricing. Selected pack: ${variant.title} for ${formatMoney(variant.price)}. For larger or production-style runs, use Bulk Orders.`;
      return;
    }

    const giftPrice = Number(variant.price || rule.defaultVariant.price || 0);
    const value = rule.valueRange(variant);
    const savingsMin = value.min - giftPrice;
    const savingsMax = value.max - giftPrice;
    const itemValue = formatMoneyRange(value.min, value.max);
    const giftPriceText = formatMoney(giftPrice);

    if (savingsMax <= 0) {
      headline.textContent = 'Individual price check';
      detail.textContent = `Comparable items individually: ${itemValue}. Gift set price: ${giftPriceText}.`;
      return;
    }

    if (savingsMin <= 0) {
      headline.textContent = `Save up to ${formatMoney(savingsMax)} with this gift set`;
      detail.textContent = `Comparable items individually: ${itemValue}. Gift set price: ${giftPriceText}. Savings depend on your selected scents, shapes, or pack size.`;
      return;
    }

    headline.textContent = `Save ${formatMoneyRange(savingsMin, savingsMax)} with this gift set`;
    detail.textContent = `Comparable items individually: ${itemValue}. Gift set price: ${giftPriceText}.`;
  }

  function initGiftSavingsFallback() {
    const rule = currentRule();
    const builder = document.querySelector('.lox-gift-bundle-builder');
    if (!rule || !builder) return;

    injectSavingsStyles();
    updateSavings(builder, rule);

    document.addEventListener('change', (event) => {
      if (!event.target?.closest) return;
      if (builder.contains(event.target) || event.target.closest('variant-selects, variant-radios, .product-form__input')) {
        window.setTimeout(() => updateSavings(builder, rule), 0);
      }
    });

    document.addEventListener('input', (event) => {
      if (builder.contains(event.target)) updateSavings(builder, rule);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftSavingsFallback);
  } else {
    initGiftSavingsFallback();
  }
})();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        if (evt.defaultPrevented) return;
        if (this.hasSelectedFileProperty()) return;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      hasSelectedFileProperty() {
        return Array.from(this.form.querySelectorAll('input[type="file"][name^="properties["]')).some(
          (input) => input.files && input.files.length > 0
        );
      }
    }
  );
}

(() => {
  const titleOverrides = {
    '/products/boujie-beach-room-spray': 'Boujie Beach Room Spray',
  };
  const cleanPath = window.location.pathname.replace(/\/$/, '');
  const overrideTitle = titleOverrides[cleanPath];
  if (!overrideTitle) return;

  const heading = document.querySelector('.product__title h1');
  if (heading && heading.textContent.trim() !== overrideTitle) {
    heading.textContent = overrideTitle;
  }
})();
